import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Pill.module.css'

export type PillTone = 'accent' | 'ink' | 'neutral' | 'positive' | 'warning' | 'onDark'

export function Pill({
  tone = 'neutral',
  className,
  children,
}: {
  readonly tone?: PillTone | undefined
  readonly className?: string | undefined
  readonly children: ReactNode
}) {
  return <span className={cn(styles.pill, styles[tone], className)}>{children}</span>
}
